import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";
import { getColumnIntoKey } from "~pages/PriceSearchV2/utils/initializerHelpers";

const usePesquisaEmbalagem = ({ formikRef, pesquisaGrupoMaterialId = 0, permitir = 0, showAll = true }) => {
  const pesquisaEmbalagemSelect = useSelect("pesquisaEmbalagens");
  const [pesquisaEmbalagem, setPesquisaEmbalagem] = useState(0);
  const [pesquisaEmbalagemObjeto, setPesquisaEmbalagemObjeto] = useState({});
  const [fila, setFila] = useState(null);

  const [pesquisaEmbalagens, setPesquisaEmbalagens] = useState([]);
  const [pesquisaGrupoMaterialEmbalagem, setPesquisaGrupoMaterialEmbalagem] = useState([]);

  const fetchPesquisaEmbalagens = async () => {
    const embalagens = [];
    await db.pesquisaEmbalagem.each((embalagem) => {
      if (showAll || embalagem.ativo || permitir == embalagem.id) embalagens.push(embalagem);
    });
    setPesquisaEmbalagens(embalagens);
  };

  const fetchPesquisaGrupoMaterialEmbalagem = async () => {
    const gruposMaterial = [];
    await db.pesquisaGrupoMaterialEmbalagem.each((grupo) => {
      gruposMaterial.push(grupo);
    });
    setPesquisaGrupoMaterialEmbalagem(gruposMaterial);
  };

  useEffect(() => {
    fetchPesquisaEmbalagens();
    fetchPesquisaGrupoMaterialEmbalagem();
  }, []);

  useEffect(() => {
    fetchPesquisaEmbalagens();
    fetchPesquisaGrupoMaterialEmbalagem();
  }, [permitir]);

  const pesquisaGrupoMaterialEmbalagens = useMemo(() => {
    const result = {};
    for (const e of pesquisaGrupoMaterialEmbalagem || []) {
      result[e.pesquisaGrupoMaterialId + "/" + e.pesquisaEmbalagemId] = true;
    }
    return result;
  }, [pesquisaGrupoMaterialEmbalagem]);

  const optionPesquisaEmbalagem = useMemo(() => {
    let temp = [];
    if (pesquisaGrupoMaterialId && pesquisaGrupoMaterialId != 0) {
      temp = (pesquisaEmbalagens || []).filter((e) =>
        e.ativo && pesquisaGrupoMaterialId
          ? Object.entries(pesquisaGrupoMaterialEmbalagens).length > 0 &&
            pesquisaGrupoMaterialEmbalagens[pesquisaGrupoMaterialId + "/" + e.id]
          : e
      );
    }
    return prepareForOptions(temp, ["nome"], "id");
  }, [pesquisaGrupoMaterialEmbalagens, pesquisaGrupoMaterialId]);

  useEffect(() => {
    if (
      pesquisaEmbalagem &&
      pesquisaGrupoMaterialId &&
      pesquisaGrupoMaterialId != 0 &&
      pesquisaGrupoMaterialEmbalagens
    ) {
      const exists = (pesquisaEmbalagens || []).find(
        (e) =>
          e.id == pesquisaEmbalagem &&
          Object.entries(pesquisaGrupoMaterialEmbalagens).length > 0 &&
          pesquisaGrupoMaterialEmbalagens[pesquisaGrupoMaterialId + "/" + e.id]
      );

      if (!exists) {
        onChangePesquisaEmbalagem({
          value: null,
        });
      }
    }
  }, [optionPesquisaEmbalagem, pesquisaGrupoMaterialId]);

  useEffect(() => {
    if (pesquisaEmbalagens?.length > 0) {
      setPesquisaEmbalagemObjeto(getColumnIntoKey({ data: pesquisaEmbalagens, prefix: "id-" }));
    }
  }, [pesquisaEmbalagens]);

  //PESQUISA-GRUPO-MATERIAL-EMBALAGEM

  useEffect(() => {
    if (
      fila &&
      pesquisaGrupoMaterialEmbalagens &&
      Object.keys(pesquisaGrupoMaterialEmbalagens).length > 0 &&
      optionPesquisaEmbalagem &&
      optionPesquisaEmbalagem.length > 0
    ) {
      setPesquisaEmbalagemSelect(fila);
    }
  }, [fila, pesquisaGrupoMaterialEmbalagens, optionPesquisaEmbalagem]);

  function setPesquisaEmbalagemSelect(value, b) {
    if (
      pesquisaEmbalagens &&
      pesquisaEmbalagens.length > 0 &&
      optionPesquisaEmbalagem &&
      optionPesquisaEmbalagem.length > 0
    ) {
      const optionEmbalagem = (pesquisaEmbalagens || []).find((optEmbalagem) => optEmbalagem.id == value);

      if (optionEmbalagem) {
        onChangePesquisaEmbalagem(
          {
            label: optionEmbalagem.nome,
            value: optionEmbalagem.id,
          },
          b
        );
      }
      setFila(null);
    } else {
      setFila(value);
    }
  }

  function onChangePesquisaEmbalagem(e, b) {
    pesquisaEmbalagemSelect.upDateValue(e.value);
    pesquisaEmbalagemSelect.upDateDefaultValue(e || "");
    const formikInstance = formikRef?.current;
    if (formikInstance) {
      formikInstance.setFieldValue("embalagemId", e.value);
      setTimeout(() => formikInstance.setFieldTouched("embalagemId", true));
    }
    setPesquisaEmbalagem(e.value);
  }

  return {
    pesquisaEmbalagemObjeto,
    pesquisaEmbalagem,
    optionPesquisaEmbalagem,
    onChangePesquisaEmbalagem,
    pesquisaEmbalagens,
    pesquisaEmbalagemSelect,
    setPesquisaEmbalagem,
    setPesquisaEmbalagemSelect,
  };
};

export default usePesquisaEmbalagem;
